export default {
  TableHead: [
    [
      {
        displayName: 'bet.datatable.number',
      },
      {
        displayName: 'bet.datatable.ticketid',
      },
      {
        displayName: 'bet.datatable.requestresponse',
      },
      {
        displayName: 'bet.datatable.retry',
      },
    ],
  ],
};
